import { useMemo, RefObject } from 'react';

import { AnimationStates } from './useAccordionAnimationState';

/**
 * Used to calculate the accordion height based on the animation state.
 */
const useAccordionHeight = (animationState: AnimationStates, htmlElementRef: RefObject<HTMLDivElement>) => {
    const height = useMemo(() => {
        switch (animationState) {
            case 'BEFORE_OPENING':
                return 0;
            case 'OPENING':
                return `${htmlElementRef.current?.scrollHeight || 0}px`;
            case 'BEFORE_CLOSING':
                return `${htmlElementRef.current?.offsetHeight || 0}px`;
            case 'CLOSING':
            case 'CLOSED':
                return 0;
            default:
                return 'auto';
        }
    }, [animationState, htmlElementRef]);

    return height;
};

export default useAccordionHeight;
